<template>
    <div class="d-flex flex-wrap mt-2 container">
      <!-- <div class="container mb-2">
        <v-divider class="mx-4" color="black"></v-divider>
        <h1 class="text-center display-3 font-weight-light mt-2 mb-2">
          Neue Gerichte
        </h1>
        <v-divider class="mx-4 mb-6" color="black"></v-divider>
        <backtohome></backtohome>
      </div> -->
      <v-row>
        <v-col cols="12" sm="6" md="4">
        <v-card
          class="mx-auto"
          max-width="344"
          style="background-color: #212121;"
        >
          <v-carousel
            hide-delimiters
            cycle
            max-height="20%"
            background-size="cover"
          >
            <v-carousel-item
              v-for="(item, i) in baomitknusprigerente"
              :key="i"
              :src="item.src"
            ></v-carousel-item>
          </v-carousel>
          <!-- <v-img src="../assets/images/tempuracaliforniacutted.png" height="200px"></v-img> -->
          <v-alert
            dense
            max-width="50%"
            color="green"
            class="text-center mx-auto mt-4"
          >
            NEUHEIT
          </v-alert>
          <v-card-title
            class="justify-center white--text font-weight-light"
            style="background-color: #212121; padding-top:0;"
          >
            Bao mit knuspriger Ente
          </v-card-title>

          <v-card-subtitle
            class="text-center white--text font-weight-light"
            style="background-color: #212121;"
          >
            (2 Stk.)<br />
            11,90 €
          </v-card-subtitle>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card
          class="mx-auto"
          max-width="344"
          style="background-color: #212121;"
        >
          <v-carousel
            hide-delimiters
            cycle
            max-height="20%"
            background-size="cover"
          >
            <v-carousel-item
              v-for="(item, i) in baomitknusprigengarnelen"
              :key="i"
              :src="item.src"
            ></v-carousel-item>
          </v-carousel>
          <!-- <v-img src="../assets/images/tempuracaliforniacutted.png" height="200px"></v-img> -->
          <v-alert
            dense
            max-width="50%"
            color="green"
            class="text-center mx-auto mt-4"
          >
            NEUHEIT
          </v-alert>
          <v-card-title
            class="justify-center white--text font-weight-light"
            style="background-color: #212121; padding-top:0;"
          >
            Bao mit knusprigen Garnelen
          </v-card-title>

          <v-card-subtitle
            class="text-center white--text font-weight-light"
            style="background-color: #212121;"
          >
            (2 Stk.)<br />
            11,90 €
          </v-card-subtitle>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card
          class="mx-auto"
          max-width="344"
          style="background-color: #212121;"
        >
          <v-carousel
            hide-delimiters
            cycle
            max-height="20%"
            background-size="cover"
          >
            <v-carousel-item
              v-for="(item, i) in baomitknusprigemhuhn"
              :key="i"
              :src="item.src"
            ></v-carousel-item>
          </v-carousel>
          <!-- <v-img src="../assets/images/tempuracaliforniacutted.png" height="200px"></v-img> -->
          <v-alert
            dense
            max-width="50%"
            color="green"
            class="text-center mx-auto mt-4"
          >
            NEUHEIT
          </v-alert>
          <v-card-title
            class="justify-center white--text font-weight-light"
            style="background-color: #212121; padding-top:0;"
          >
            Bao mit knusprigem Huhn
          </v-card-title>

          <v-card-subtitle
            class="text-center white--text font-weight-light"
            style="background-color: #212121;"
          >
            (2 Stk.)<br />
            11,90 €
          </v-card-subtitle>
        </v-card>
      </v-col>
      <v-col cols="12" sm="6" md="4">
        <v-card
          class="mx-auto"
          max-width="344"
          style="background-color: #212121;"
        >
          <v-carousel
            hide-delimiters
            cycle
            max-height="20%"
            background-size="cover"
          >
            <v-carousel-item
              v-for="(item, i) in baomittofu"
              :key="i"
              :src="item.src"
            ></v-carousel-item>
          </v-carousel>
          <!-- <v-img src="../assets/images/tempuracaliforniacutted.png" height="200px"></v-img> -->
          <v-alert
            dense
            max-width="50%"
            color="green"
            class="text-center mx-auto mt-4"
          >
            NEUHEIT
          </v-alert>
          <v-card-title
            class="justify-center white--text font-weight-light"
            style="background-color: #212121; padding-top:0;"
          >
            Bao mit knusprigem Tufo
          </v-card-title>

          <v-card-subtitle
            class="text-center white--text font-weight-light"
            style="background-color: #212121;"
          >
            (2 Stk.)<br />
            11,90 €
          </v-card-subtitle>
        </v-card>
      </v-col>
      </v-row>
  
      <div class="container">
        <h1
          class="text-center display-2 font-weight-thin mt-6"
          style="color: #1B5E20"
        >
          Sauce auswählen
        </h1>
        <br />
        <div class="container text-center">
          <v-alert text outlined color="#FF6F00" icon="mdi-fire">
            SCHARFE MAYO SAUCE
          </v-alert>
          <v-alert text outlined color="#F44336" icon="mdi-fire">
            CHILI SAUCE
          </v-alert>
          <v-alert text outlined color="#FF3D00" icon="mdi-fire">
            SÜß-CHILI SAUCE
          </v-alert>
          <v-alert text outlined color="#6D4C41">
            SESAM SAUCE
          </v-alert>
          <!-- <v-alert text outlined color="#4E342E">
            POKE SAUCE
          </v-alert> -->
          <v-alert text outlined color="#3E2723">
            TERIYAKI SAUCE
          </v-alert>
        </div>

      </div>
    </div>
  </template>
  
  <script>
  // import Backtohome from './Backtohome.vue';
  export default {
    // components: { Backtohome },
    data() {
      return {
        baomitknusprigemhuhn: [
        {
          src: require('../assets/images/baohuhn.jpg'),
        },
      ],
      baomitknusprigengarnelen: [
        {
          src: require('../assets/images/baogarnelen.jpg'),
        },

      ],
      baomitknusprigerente: [
        {
          src: require('../assets/images/baoente.jpg'),
        },
      ],      baomittofu: [
        {
          src: require('../assets/images/baotofu.jpg'),
        },
      ],
      };
    },
    methods: {
      top() {
        window.scrollTo(0, 0);
      },
    },
    created() {
      this.top();
    },
  };
  </script>
  
  <style lang="scss" scoped></style>
  